import apiClient from './apiClient';

export const udfApi = {
    /**
     * List all UDFs for the current user
     */
    listUDFs: async () => {
        const response = await apiClient.get('/udfs');
        return response.data;
    },

    /**
     * Create a new custom UDF or import from BigQuery
     */
    createUDF: async (payload) => {
        const response = await apiClient.post('/udfs', payload);
        return response.data;
    },

    /**
     * Get details of a specific UDF
     */
    getUDF: async (udfId) => {
        const response = await apiClient.get(`/udfs/${udfId}`);
        return response.data;
    },

    /**
     * Update a custom UDF
     */
    updateUDF: async (udfId, payload) => {
        const response = await apiClient.patch(`/udfs/${udfId}`, payload);
        return response.data;
    },

    /**
     * Delete a UDF
     */
    deleteUDF: async (udfId) => {
        const response = await apiClient.delete(`/udfs/${udfId}`);
        return response.data;
    },

    /**
     * Re-generate UDF description using LLM
     */
    generateDescription: async (udfId) => {
        const response = await apiClient.post(`/udfs/${udfId}/generate-description`);
        return response.data;
    }
};
